import { Box, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import cx from 'classnames';
import React from 'react';
import useStyles from './styles';
import { SortableHandle as sortableHandle } from 'react-sortable-hoc';
import { IFeaturedCardObject, FeaturedCardType } from '../../../../services/types';
import { TargetTypeLabel } from '../../../../components/Curation/Labels';

export interface IFeaturedCardProps {
  type: FeaturedCardType;
  title: string;
  coverUrl?: string | null;
  object?: IFeaturedCardObject;
  targetId?: string;
  onPressEdit?: () => void;
  onPressRemove?: () => void;
  isEditing: boolean;
}

const DraggableArea = sortableHandle((props: { children: React.ReactNode }) => <div>{props.children}</div>);

const regex = /(http[s]?:\/\/|data:image)/;

const FeaturedCard = (props: IFeaturedCardProps): JSX.Element => {
  const classes = useStyles();
  let coverUrl = props.coverUrl || '';
  if (!props.coverUrl && props.object && props.object.story && props.object.story.seasons && props.object.story.seasons.length) {
    const srcSeason =
      props.type === 'story' ? props.object.story.seasons[0] : props.object.story.seasons.filter(s => s.id === Number(props.targetId))[0];
    coverUrl = srcSeason.additionalCoverHUrl || srcSeason.coverUrl || '';
  }

  return (
    <Box className={classes.featuredCardBox}>
      <DraggableArea>
        {coverUrl && (
          <img
            src={regex.test(coverUrl) ? `${coverUrl}?w=320` : `${process.env.CDN_URL}/${coverUrl}?w=320`}
            className={classes.featuredCardCoverImg}
          />
        )}
      </DraggableArea>
      <Box className={classes.featuredCardBottom}>
        <TargetTypeLabel type={props.type} />
        <span className={classes.featuredCardTitle}>{props.title}</span>

        {props.isEditing && (
          <IconButton
            className={cx(classes.featuredCardButtons, classes.featuredCardEditButton)}
            onClick={() => {
              props.onPressEdit?.();
            }}
          >
            <EditIcon style={{ fontSize: '1.2rem' }} />
          </IconButton>
        )}

        {props.isEditing && (
          <IconButton
            className={classes.featuredCardButtons}
            onClick={() => {
              props.onPressRemove?.();
            }}
          >
            <DeleteIcon style={{ fontSize: '1.2rem' }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default FeaturedCard;
